import React from 'react';

import { AddContact } from '@components/utilities/Contact/AddContact';

export const AddConsignee: React.FC = () => (
  <AddContact contactType="consignee" ownedContactType="receiver" />
);
